var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container old-globals"},[_c('case-build-assistant-container',{on:{"added":_vm.onCaseAdded,"close":_vm.onCaseClosed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }